<cigna-omni-comm-channel
  *ngIf="content$ | async as content"
  data-omni-qa="cigna-omni-comm-channel-eap"
>
  <cigna-omni-comm-channel-header omniQaTag="omni-comm-channel-eap-header">
    {{ content.header }}
  </cigna-omni-comm-channel-header>
  <cigna-omni-comm-channel-subheader
    omniQaTag="omni-comm-channel-eap-subheader"
  ></cigna-omni-comm-channel-subheader>
  <cigna-omni-comm-channel-content
    *ngIf="content.body || content.icon"
    [icon]="content.icon"
    [iconColors]="iconColors"
    [iconData]="iconData"
    omniQaTag="omni-comm-channel-eap-content-icon"
  >
    <ng-container *ngFor="let line of content.body; index as i">
      <p
        [class.is-bold]="line.bold"
        [attr.data-omni-qa]="'omni-comm-channel-eap-content-' + i"
      >
        {{ line.text }}
      </p>
    </ng-container>
  </cigna-omni-comm-channel-content>
  <cigna-omni-comm-channel-button
    *ngIf="content.buttonText !== ''"
    (interaction)="interact(content)"
    [copy]="'Chat with us'"
    omniQaTag="omni-comm-channel-eap-button"
  ></cigna-omni-comm-channel-button>
</cigna-omni-comm-channel>
